// @flow
import React from 'react';
import { useField } from 'formik';
import classNames from 'classnames';
import TextareaAutosize from 'react-autosize-textarea';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  label: string,
  placeholder: string,
  name: string,
  className?: string,
};

export const FormTextArea = ({
  label,
  className = '',
  id = '',
  ...props
}: Props) => {
  const [field, meta] = useField(props);
  const hasError = meta.touched && meta.error;
  const error = meta.error;

  if (hasError) {
    label = error;
  }

  const containerClass = classNames(
    'form-textarea form-field normal-scroll',
    className,
    {
      'field-error': hasError,
    }
  );

  return (
    <div className={containerClass}>
      <TextareaAutosize
        id={id || field.name}
        rows={1}
        maxRows={4}
        {...field}
        {...props}
      />
      <label htmlFor={id || field.name}>{label}</label>
    </div>
  );
};
